import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useChfarBookParams = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const itineraryId = params.get("itineraryId");
  const contractId = params.get("contractId");
  const flightShopType = params.get("flightShopType");

  return useMemo(
    () => ({
      itineraryId,
      contractId,
      flightShopType,
    }),
    [itineraryId, contractId, flightShopType]
  );
};
